import BpkImage from '@skyscanner/backpack-web/bpk-component-image';
import BpkLink from '@skyscanner/backpack-web/bpk-component-link';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { googleTranslateLogo } from '../../common/img/index';

import STYLES from './GoogleTranslationLogo.module.scss';

type Props = {
  className?: string;
};

const cls = cssModules(STYLES);

const GoogleTranslationLogo = ({ className }: Props) => (
  <BpkLink
    implicit
    href="https://translate.google.com"
    blank
    className={STYLES.TranslationLogo}
    tabIndex={-1}
    aria-hidden="true"
  >
    <BpkImage
      src={googleTranslateLogo}
      altText=""
      className={cls('TranslationLogo__img', className)}
      aspectRatio={109 / 16}
    />
  </BpkLink>
);

export default GoogleTranslationLogo;
